import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import './LandingPage.css';

const LandingPage = () => {
  const { settings } = useSettings();
  const companyName = settings?.company?.name || 'Hotel Booking';
  const copyrightText = settings?.company?.copyright?.trim();
  const currentYear = new Date().getFullYear();
  const defaultCopyright = `Copyright © ${currentYear} ${companyName}. All rights reserved.`;

  return (
    <div className="landing-page">
      <header className="landing-header">
        <div className="landing-header-inner">
          {settings?.company?.logo ? (
            <img src={settings.company.logo} alt={companyName} className="landing-logo" />
          ) : (
            <span className="landing-logo-text">{companyName}</span>
          )}
          <nav className="landing-nav">
            <Link to="/list-your-property" className="landing-nav-link">List your property</Link>
            <Link to="/sy-admin/login" className="landing-nav-link landing-nav-cta">Admin login</Link>
          </nav>
        </div>
      </header>

      <main className="landing-main">
        <section className="landing-hero">
          <h1 className="landing-hero-title">
            Book hotels, spas, tours & travel packages
          </h1>
          <p className="landing-hero-subtitle">
            Find the best stays and experiences. Download our app to explore and book.
          </p>
          <div className="landing-hero-actions">
            <a
              href="https://play.google.com/store/apps/details?id=com.weotp.app&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
              className="landing-btn landing-btn-primary"
              aria-label="Download Synilogic StayNTravel app on Google Play"
            >
              Get the app
            </a>
            <Link to="/list-your-property" className="landing-btn landing-btn-secondary">
              List your property
            </Link>
          </div>
        </section>

        <section className="landing-features">
          <div className="landing-features-grid">
            <div className="landing-feature-card">
              <span className="landing-feature-icon" aria-hidden>🏨</span>
              <h3>Hotels</h3>
              <p>Comfortable stays for every budget</p>
            </div>
            <div className="landing-feature-card">
              <span className="landing-feature-icon" aria-hidden>💆</span>
              <h3>Spas</h3>
              <p>Relax and rejuvenate</p>
            </div>
            <div className="landing-feature-card">
              <span className="landing-feature-icon" aria-hidden>🎫</span>
              <h3>Tours & Activities</h3>
              <p>Experiences and adventures</p>
            </div>
            <div className="landing-feature-card">
              <span className="landing-feature-icon" aria-hidden>✈️</span>
              <h3>Travel Packages</h3>
              <p>Curated holiday packages</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="landing-footer-inner">
          <p className="landing-copyright">
            {copyrightText || defaultCopyright}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
